export const ContactBlock = {
  name: "Contact",
  nameI18n: "builder_ui.block_category.contact",
} as const;

export const CallToActionBlock = {
  name: "Call to Action",
  nameI18n: "builder_ui.block_category.cta",
} as const;

export const ContentBlock = {
  name: "Content",
  nameI18n: "builder_ui.block_category.content",
} as const;

export const NewsletterPostsCategory = {
  name: "Newsletter posts",
  nameI18n: "builder_ui.block_category.newsletter_posts",
} as const;

export const ColumnBlock = {
  name: "Column",
  nameI18n: "builder_ui.block_category.column",
} as const;

export const LayoutBlock = {
  name: "Layout",
  nameI18n: "builder_ui.block_category.layout",
} as const;

export const TemplateBlock = {
  name: "Template",
  nameI18n: "builder_ui.block_category.template",
} as const;

export const SectionsBlock = {
  name: "Sections",
  nameI18n: "builder_ui.block_category.sections",
} as const;

export const GalleryBlock = {
  name: "Gallery",
  nameI18n: "builder_ui.block_category.gallery",
} as const;

export const BasicBlock = {
  name: "Basic",
  nameI18n: "builder_ui.block_category.basic",
} as const;

export const HeroHeadersBlock = {
  name: "Hero Headers",
  nameI18n: "builder_ui.block_category.hero",
} as const;

export const PricingBlock = {
  name: "Pricing",
  nameI18n: "builder_ui.block_category.pricing",
} as const;

export const OtherBlock = {
  name: "Other",
  nameI18n: "builder_ui.block_category.other",
} as const;

export const MediaBlock = {
  name: "Media",
  nameI18n: "builder_ui.block_category.media",
} as const;

export const ProductShotBlock = {
  name: "Product Shot",
  nameI18n: "builder_ui.block_category.product_shot",
} as const;

export const TestimonialsBlock = {
  name: "Testimonials",
  nameI18n: "builder_ui.block_category.testimonials",
} as const;

export const TextBlock = {
  name: "Text",
  nameI18n: "builder_ui.block_category.text",
} as const;

export const ActionsBlock = {
  name: "Actions",
  nameI18n: "builder_ui.block_category.actions",
} as const;

export const BlogBlock = {
  name: "Blog",
  nameI18n: "builder_ui.block_category.blog",
} as const;

export const FeaturesBlock = {
  name: "Features",
  nameI18n: "builder_ui.block_category.features",
} as const;

export const TeamBlock = {
  name: "Team",
  nameI18n: "builder_ui.block_category.team",
} as const;

export const StatsBlock = {
  name: "Stats",
  nameI18n: "builder_ui.block_category.stats",
} as const;

export const FAQsBlock = {
  name: "FAQs",
  nameI18n: "builder_ui.block_category.faqs",
} as const;

export const ProfileFieldsBlock = {
  name: "Profile fields",
  nameI18n: "builder_ui.block_category.profile_fields",
  tooltipDescriptionI18n:
    "builder_ui.block_category.profile_fields_tooltip_description",
  maxVisibleItems: 8,
} as const;

export const GeneralFieldsBlock = {
  name: "General",
  nameI18n: "builder_ui.block_category.general_fields",
} as const;

export type BlockCategoryName =
  | "About Us"
  | (typeof ActionsBlock)["name"]
  | (typeof BasicBlock)["name"]
  | (typeof BlogBlock)["name"]
  | "Buttons"
  | (typeof CallToActionBlock)["name"]
  | (typeof ContactBlock)["name"]
  | (typeof ContentBlock)["name"]
  | (typeof NewsletterPostsCategory)["name"]
  | (typeof ColumnBlock)["name"]
  | (typeof GalleryBlock)["name"]
  | (typeof GeneralFieldsBlock)["name"]
  | (typeof HeroHeadersBlock)["name"]
  | "Homepage"
  | (typeof LayoutBlock)["name"]
  | (typeof MediaBlock)["name"]
  | (typeof FeaturesBlock)["name"]
  | (typeof FAQsBlock)["name"]
  | (typeof OtherBlock)["name"]
  | (typeof ProfileFieldsBlock)["name"]
  | (typeof SectionsBlock)["name"]
  | (typeof TemplateBlock)["name"]
  | "Feature Card"
  | "Sales"
  | (typeof StatsBlock)["name"]
  | (typeof PricingBlock)["name"]
  | (typeof TestimonialsBlock)["name"]
  | (typeof TextBlock)["name"]
  | (typeof TeamBlock)["name"]
  | "Stack"
  | (typeof ProductShotBlock)["name"];
